export const setSessionStorageItem = (key: string, data: string): void => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(key, data);
  }
};
